// @flow
import React, { Children, cloneElement, PureComponent } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import cx from 'classnames';
import LinkButton from '../layout/LinkButton';
import { tagEvent } from '../../util/tracking/Localytics';
import { Icon } from 'react-fast-ui';

const TAB_KEY_TYPE = PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]);

export const getFastStatTabStyles = (primaryColor) => {
  return ({
    containerStyle: { display: 'flex', justifyContent: 'space-between', position: 'relative', paddingBottom: 8 },
    listStyle: { marginLeft: -6 },
    listCX: 'list-unstyled display-flex pd-none hidden-print mg-bottom-none futura-pt-bold',
    labelLICX: 'futura-pt-bold cursor-pointer',
    labelLIStyle: {
      padding: '2px 8px',
      borderRadius: 5,
      marginRight: 14,
      fontSize: 18,
      letterSpacing: 0.42,
      color: 'rgba(255, 255, 255, 0.70)',
    },
    selectedStyle: { backgroundColor: '#FFFFFF', color: `#${primaryColor}` },
    linkCX: 'color-gray-background-darken',
    linkStyle: {},
    selectedLinkCX: '',
  });
};

export const FASTSTAT_SUB_TAB_STYLES = {
  containerStyle: {
    display: 'flex',
    justifyContent: 'space-between',
    position: 'relative',
    borderBottom: '1px solid #d8d8d8'
  },
  listStyle: { marginLeft: -6 },
  listCX: 'list-unstyled pd-none hidden-print mg-bottom-none pd-left-xl pd-right-xl display-flex helvetica-neue-bold',
  labelLICX: 'display-inline-block display-flex align-items-center justify-content-center',
  labelLIStyle: {
    padding: '0 16px',
    cursor: 'pointer',
    position: 'relative',
    fontSize: 14,
    borderBottomWidth: 4,
    borderBottomStyle: 'solid',
    borderBottomColor: 'transparent',
    height: 44,
    paddingTop: 7
  },
  linkCX: 'color-gray-background-darken',
  linkStyle: {},
  selectedLinkCX: '',
  paddingLeft: 6,

};


export class Tab extends PureComponent {

  static propTypes = {
    disabled: PropTypes.bool,
    selectedKey: TAB_KEY_TYPE,
    tabKey: TAB_KEY_TYPE,
  };

  static defaultProps = {
    disabled: false,
  };

  isSelected = () => _.isEqual(this.props.tabKey, this.props.selectedKey);

  // lifecycle
  render() {
    const { className, children, style, ...rest } = this.props;

    return (!this.isSelected() ? null :
        <div className={className} style={style} {...rest}>
          {
            (!children || children.length === 0) ? null : Children.only(children)
          }
        </div>
    );
  }
}

export default class FASLinkTabs extends PureComponent {
  static contextTypes = {
    contentWidth: PropTypes.number,
    router: PropTypes.object,
  };

  static propTypes = {
    onSelect: PropTypes.func,
    selectedKey: TAB_KEY_TYPE,
    isSubTabs: PropTypes.bool,
    isDefaultPrimaryColor: PropTypes.bool,
  };

  static defaultProps = {
    onSelect: (null: ?Function),
    selectedKey: (null: ?string),
    isSubTabs: false,
    isDefaultPrimaryColor: true,
    rightAlignComponent: null,
  };

  handleClickTab = (tabKey: string) => {
    const { onSelect } = this.props;
    return onSelect ? onSelect(tabKey) : null;
  };

  // lifecycle
  render() {
    const { router: { location: { query } } } = this.context;
    const {
      className,
      children,
      selectedKey,
      listStyle,
      style,
      isSubTabs,
      rightAlignComponent,
      primaryColor,
      isDefaultPrimaryColor,
    } = this.props;
    let STYLE;
    let tabColor;

    if (!isSubTabs) {
      STYLE = getFastStatTabStyles(primaryColor);
    } else {
      STYLE = FASTSTAT_SUB_TAB_STYLES;
    }

    if (!isDefaultPrimaryColor) {
      tabColor = '#000000';
    } else {
      tabColor = `#${primaryColor}`;
    }

    return (
      <div className="hidden-print">
        <div style={{ ...style, ...STYLE.containerStyle }}>
          <div style={isSubTabs ? { width: '100%', margin: '0 auto', } : {}}>
            <ul
              className={cx(STYLE.listCX, className)}
              style={{ ...STYLE.listStyle, listStyle }}>
              {
                Children.map(children, (child: Object, ix: number) => {
                  const { disabled, href, label, tabKey } = child.props;
                  const isSelected = (selectedKey === tabKey);
                  const onClick = disabled ? null : () => this.handleClickTab(tabKey);
                  const className = isSelected ? STYLE.selectedLinkCX : STYLE.linkCX;

                  return (
                    <LinkButton
                      disabled={disabled}
                      href={{ pathname: href, query }}
                      onClick={onClick}
                      size="lg"
                      className={className}>
                      <li
                        key={ix}
                        onClick={onClick}
                        className={cx(STYLE.labelLICX, { [ STYLE.selectedCX ]: isSelected })}
                        style={{
                          color: tabColor,
                          ...STYLE.labelLIStyle,
                          ...(isSelected ? {
                            borderBottomColor: tabColor,
                            ...STYLE.selectedStyle,
                          } : { borderBottomColor: 'transparent' })
                        }}
                        id={`${tabKey}-${ix}`}
                        name={`${tabKey}-${ix}`}
                      >{label}</li>
                    </LinkButton>
                  );
                })
              }
            </ul>
            {rightAlignComponent}
          </div>
        </div>
        {
          Children.map(children, (child: Object) => {
            return cloneElement(child, { selectedKey });
          })
        }
      </div>
    );
  }
}